import { LoginApprovalDeviceRequest, LoginApprovalHistoryRequest, LoginApprovalRequest, LoginReviewBody } from "@/domain/entities/ManagementLoginApproval";

export class ManagementLoginApprovalEndpoint {
  // approval 
  getLoginApprovalList(params: LoginApprovalRequest): string {
    return `/horde/v1/device-auth/login-requests?${params.toQueryString()}`;
  }

  postLoginApprovalReview(): string {
    return `/horde/v1/device-auth/review`;
  }

  // devices
  getLoginApprovalDevicesList(params: LoginApprovalDeviceRequest): string {
    return `/horde/v1/device-auth/team?${params.toQueryString()}`;
  }

  postLoginApprovalDeviceDelete(): string {
    return `/horde/v1/device-auth/team/remove`;
  }

  // history
  getLoginApprovalHistoryList(params: LoginApprovalHistoryRequest): string {
    return `/horde/v1/device-auth/login-history?${params.toQueryString()}`;
  }
}